import * as React from 'react';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import StatusLabel from 'components/status-label/StatusLabel';

import ContentApprovalAsset from './ContentApprovalAsset';

import { t } from 'utils/language';

import type { ClientApprovalBucketItem, DeliverableAttachmentApprovalStatus, GalleryModalItem, StatusLabelType } from 'types';

import type { SyntheticEvent } from 'react';

const STATUS_LABEL_MAP: Record<string, StatusLabelType> = {
  approved: 'success',
  pending: 'warning',
  declined: 'danger',
  not_required: 'neutral'
};

type Props = {
  item: ClientApprovalBucketItem,
  lookName: string,
  galleryItems: Array<GalleryModalItem>,
  galleryItemIndex: number,
  onDeleteItem: (a: SyntheticEvent<HTMLElement>) => void
};

class ContentApprovalLookItem extends React.PureComponent<Props> {
  renderCross(): React.ReactNode {
    const { item, onDeleteItem } = this.props;

    return (
      <div
        id={String(item.id)}
        className="content-approval-look-item__cross"
        onClick={onDeleteItem}
      >
        <SVGDynamicIcon
          name="cross-inside-circle-custom-bg-white-fg"
          width={16}
          height={16}
        />
      </div>
    );
  }

  renderApprovalStatus(approvalStatus: DeliverableAttachmentApprovalStatus): React.ReactNode {
    return (
      <div className="content-approval-look-item__status">
        <StatusLabel
          size="micro"
          type={STATUS_LABEL_MAP[approvalStatus]}
          label={t(`deliverable_approval.status.${approvalStatus}`)}
        />
      </div>
    );
  }

  renderAsset(): React.ReactNode {
    const { item, lookName, galleryItems, galleryItemIndex } = this.props;
    const approvalStatus = item.approvalStatus;

    return (
      <div className="content-approval-look-item__asset">
        <ContentApprovalAsset
          item={item}
          lookName={lookName}
          galleryItems={galleryItems}
          galleryItemIndex={galleryItemIndex}
          showOverlay
        />
        {this.renderCross()}
        {approvalStatus && this.renderApprovalStatus(approvalStatus)}
      </div>
    );
  }

  renderFooter(): React.ReactNode {
    const { item } = this.props;

    return (
      <div
        className="content-approval-look-item__footer text-overflow-ellipsis"
        title={item.fileName}
      >
        {item.fileName}
      </div>
    );
  }

  render(): React.ReactNode {
    return (
      <div className="content-approval-look-item">
        {this.renderAsset()}
        {this.renderFooter()}
      </div>
    );
  }
}

export default ContentApprovalLookItem;
